import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/HomePage';
import Services from './pages/ServicesPage';
import About from './pages/AboutPage';
import Projects from './pages/ProjectsPage';
import ContactUs from './pages/ContactPage';
import Careers from './pages/CareersPage';
import Preloader from './components/Preloader';
import './App.css';

const App = () => {
  return (
    <Router>
      <Preloader />
      <Navbar />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
      </main>

    </Router>
  );
};

export default App;
